import React, { useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import CurateDataCont from "./CurateDataCont";
import { FiPlusCircle } from "react-icons/fi";
import { IoIosRefresh } from "react-icons/io";
const CurateDataTable = () => {
  document.title = "Data Curation";
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [showSampleFile, setShowSampleFile] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [SearchItem , setSearchItem] = useState('');
  const [refresh, setRefresh] = useState(0);
  const closeModal = () => {
    setAddModalOpen(false);
    setSelectedIndustry("");
    setError("");
    setShowSampleFile(false)
    setFile(null);
  };

  const openAddModal = () => {
    setAddModalOpen(true);
  };

  const handleRefresh = () => {
    setRefresh(prev => prev+1);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
              <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width:'60%' ,marginTop:8}}>
                  <form style={{ width: "100%", marginBottom: 12 }}>
                    <input
                      type="text"
                      value={searchQuery}
                      placeholder="Type here to search"
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  </form>
                  <h6 className="mb-2" style={{ fontSize: 20, whiteSpace: 'nowrap' }}>
                    Total Files: {totalItems}
                  </h6>
                </div>
                <div style={{display: 'flex', justifyContent: 'end'}}>
                <button
                  onClick={handleRefresh}
                  style={{
                    padding: '7px 20px',
                    backgroundColor: "#4b38b3",
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer',
                    marginRight: '10px'
                  }}
                >
                  <IoIosRefresh style={{ fontSize: 20, marginRight: 5 }} />
                  Refesh
                </button>
                <button
                  onClick={openAddModal}
                  style={{
                    padding: '7px 20px',
                    backgroundColor: "#4b38b3",
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer'
                  }}
                >
                  <FiPlusCircle style={{ fontSize: 20, marginRight: 5 }} />
                  Add File
                </button>
                </div>
              </CardHeader>


                <CardBody>
                  <CurateDataCont
                    isAddModalOpen= {isAddModalOpen}
                    closeModal={closeModal}
                    setAddModalOpen={setAddModalOpen}
                    selectedIndustry={selectedIndustry}
                    setSelectedIndustry={setSelectedIndustry}
                    file = {file}
                    setFile={setFile}
                    error = {error}
                    setError={setError}
                    showSampleFile={showSampleFile}
                    setShowSampleFile={setShowSampleFile}
                    setTotalItems={setTotalItems}
                    totalItems={totalItems}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    SearchItem={SearchItem}
                    setSearchItem={setSearchItem}
                    refresh={refresh}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CurateDataTable;
